import { post } from '@/common/request/index';

const templateMap = new Map([
  ['list', '/categoryTemplate/page'],
  ['detail', '/categoryTemplate/detail']
]);

export default templateMap;

/**
 * 属性模版详情
 * https://yapi.lanhanba.com/project/399/interface/api/47053
 */
export function resourceTemplateDetail(params?: any) {
  return post('/tenant/property/template/detail', { ...params }, { needCancel: false, proxyApi: '/resserv' });
}

/**
 * 属性解析
 * https://yapi.lanhanba.com/project/399/interface/api/47158
 */
export function propertyValueAnalysis(params?: any) {
  return post('/tenant/property/analysis', params, { proxyApi: '/resserv' });
}
